export const OLD_TASKS_TAB_NAME = 'oldTasks';
export const SHIFT_TASKS_TAB_NAME = 'shiftTasks';
export const TASK_TEMPLATES_TAB_NAME = 'taskTemplates';
export const TABS_DICTIONARY = {
  [OLD_TASKS_TAB_NAME]: {
    label: 'Tasks',
    value: OLD_TASKS_TAB_NAME,
  },
  [SHIFT_TASKS_TAB_NAME]: {
    label: 'Shift Tasks',
    value: SHIFT_TASKS_TAB_NAME,
  },
  [TASK_TEMPLATES_TAB_NAME]: {
    label: 'Task Templates',
    value: TASK_TEMPLATES_TAB_NAME,
  },
};
export const ROUTES_DICTIONARY = {
  [OLD_TASKS_TAB_NAME]: 'tasks',
  [SHIFT_TASKS_TAB_NAME]: 'shiftTasks.instances',
  [TASK_TEMPLATES_TAB_NAME]: 'shiftTasks.templates',
};
